import React from 'react';
import ReactEcharts from 'echarts-for-react';
import _ from 'lodash';
import numbro from 'numbro';

function tooltipFormatter(unit, mantissa = 0, params) {
  const colorSpan = (color) => `<br /><span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${ color }"></span>`;
  let str = `<span>${ params.seriesName }</span>`;

  const value = _.isObject(params.data) ? params.data.value : params.data;
  const valueLabel = numbro(value).format({
    thousandSeparated: true,
    mantissa,
  });
  const percentageFormatted = numbro(_.get(params, 'data.percentage') / 100).format({
    output: 'percent',
    mantissa: 2
  });
  const paramValue = `<span>${ colorSpan(params.color) } ${ _.get(params, 'data.name') }: ${ valueLabel }${ unit ? ` ${ unit }` : '' } (${ percentageFormatted })</span>`;

  str += paramValue;

  return str;
}

export default function SunburstChart({
  serieTitle,
  data,
  unit,
  mantissa,
}) {
  return (
    <ReactEcharts
      style={{ height: 240, width: 320 }}
      option={{
        tooltip: {
          confine: true,
          trigger: 'item',
          textStyle: {
            align: 'left',
            color: '#444',
            fontSize: 13
          },
          backgroundColor: '#FFFFFF',
          borderColor: 'rgba(0, 0, 0, 0.1)',
          borderWidth: 1,
          extraCssText: 'box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);',
          formatter: tooltipFormatter.bind(this, unit, mantissa)
        },
        series: {
          type: 'sunburst',
          data: data,
          name: serieTitle,
          itemStyle: {
            borderRadius: 7,
            borderWidth: 2
          },
          label: {
            show: false
          },
          levels: [
            {
              itemStyle: {
                color: '#DEDEDE'
              },
            },
            {
              r0: '15%',
              r: '75%',
              itemStyle: {
                borderWidth: 2
              },
              label: {
                rotate: 'tangential'
              }
            },
            {
              r0: '75%',
              r: '95%',
              label: {
                align: 'right'
              }
            },
          ],
        }
      }}
    />
  );
}
